export const ResultNbcPage = () => {
  return <h1>ResultNbcPage</h1>;
};
